<header class="page-header">
	<h2>Matter Defaults</h2>
</header>

<div class="mb-4 mt-10">
	<app-checkbox
		type="clear"
		[ngModel]="settings?.collapseSpouseSurnames"
		(ngModelChange)="setCollapseSpouseSurnames($event)"
		>Show only unique last names</app-checkbox
	>
</div>

<atomic-button-group
	[(ngModel)]="currentPage"
	[options]="pages"
	class="mb-3"
></atomic-button-group>

<ng-container *ngIf="currentPage === 'general'">
	<app-general-defaults></app-general-defaults>
</ng-container>

<ng-container *ngIf="currentPage === 'soac'">
	<app-soa-defaults></app-soa-defaults>
</ng-container>

<ng-container *ngIf="currentPage === 'soa'">
	<app-adjustment-defaults></app-adjustment-defaults>
</ng-container>

<ng-container *ngIf="currentPage === 'tl'">
	<app-trust-ledger-defaults></app-trust-ledger-defaults>
</ng-container>
